import React from 'react'
import PropTypes from 'prop-types'
import { isNil, has } from 'ramda'

import strings from 'utils/strings'
import { isArray } from 'utils/types'

import { useDispatch } from 'react-redux'
import { useMakeSelector } from 'hooks/redux'

import { makeSignalSelector } from 'selectors/feature/inputs'
import { makeConditionSelector } from 'selectors/feature/conditions'
import { setConditionField } from 'actions/feature/conditions'
import { RadioButtonGroup, Paragraph } from 'components/patterns'
import IconInfo from 'components/patterns/Icon/components/Icon__Info'
import { TwoPositionMessage } from './InputPositionEditor.style'

const positionButtons = (uriOptionsByPosition) => {
  if (uriOptionsByPosition && isArray(uriOptionsByPosition)) {
    return uriOptionsByPosition.map(({ value, position }) => ({
      value: isNil(value) ? '' : value,
      text: position,
      disabled: isNil(value),
    }))
  }
  return null
}

const InputPositionEditor = ({ uri }) => {
  const dispatch = useDispatch()
  const condition = useMakeSelector(makeConditionSelector, { queryUri: uri })
  const { uriOptionsByPosition, inputUri } = condition
  const currentSignal = useMakeSelector(makeSignalSelector, {
    signal: inputUri,
  })
  const hasThreePosition = has('relatedInputs', currentSignal)
  function onInputPositionChange(value) {
    dispatch(setConditionField(uri, 'inputUri', value))
    dispatch(setConditionField(uri, 'signal', value))
  }

  return (
    <>
      <RadioButtonGroup
        vertical
        label={strings.position}
        onChange={(e) => onInputPositionChange(e.target.value)}
        currentValue={inputUri}
        buttons={positionButtons(uriOptionsByPosition)}
        radioGroupClassName="input-position-radio-group"
      />
      {!hasThreePosition && (
        <TwoPositionMessage>
          <IconInfo
            fill="rgba(79, 87, 100, 0.87)"
            style={{
              display: 'inline-block',
              verticalAlign: 'middle',
              marginRight: '4px',
            }}
          />
          <Paragraph size="small">{strings.up_position_only}</Paragraph>
        </TwoPositionMessage>
      )}
    </>
  )
}

InputPositionEditor.propTypes = {
  uri: PropTypes.string,
}

export default InputPositionEditor
